export const formatAssignmentResendToast = (result = {}) => {
  const queued = result.queued ?? 0
  if (queued > 0) {
    return queued === 1
      ? 'Assignment resent - delivery is now pending.'
      : `Assignment resent to ${queued} participants - delivery is now pending.`
  }
  if (result.skippedThrottled > 0) {
    return 'Assignment resend skipped - a resend was already sent recently.'
  }
  return 'No eligible assignments to resend.'
}
